import duration from './video/duration'

const video = { duration }

export default video
